export default __webpack_public_path__ + "logo.dcf08836b007f8f8919bd7e139e171dc.svg";